export enum ZoneSelectionBoxHandlers {
	None = 0,
	TopLeft = 1,
	Top = 2,
	TopRight = 4,
	Left = 8,
	Right = 16,
	BottomLeft = 32,
	Bottom = 64,
	BottomRight = 128,
	All = 255,
	// eslint-disable-next-line @typescript-eslint/prefer-literal-enum-member
	Corners = 1 + 4 + 32 + 128,
	// eslint-disable-next-line @typescript-eslint/prefer-literal-enum-member
	Sides = 2 + 8 + 16 + 64,
}
